import type { AdminTypes } from '@inspiren-monorepo/virtual-care/api-contracts';

import { Api } from '../../../utility/client';

export const getUnits = async () => {
  const res = await Api.get<AdminTypes.UnitDto[]>('/admin/v1/units');
  return res.data;
};
